import { render, staticRenderFns } from "./comp_BookEditorTab-Inscription.vue?vue&type=template&id=3be3bdaf&scoped=true&"
import script from "./comp_BookEditorTab-Inscription.vue?vue&type=script&lang=js&"
export * from "./comp_BookEditorTab-Inscription.vue?vue&type=script&lang=js&"
import style0 from "./comp_BookEditorTab-Inscription.vue?vue&type=style&index=0&id=3be3bdaf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be3bdaf",
  null
  
)

export default component.exports